module.exports = __webpack_public_path__ + "static/media/capitalsphere_landing2.22220a96.png";